import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s, ui } from '../styles/theme'
import { GATEABLE_FEATURES } from '../config/features'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'
const SRV = 'https://srv.seux.com.tr'

function CodeBox({ code }) {
  const [copied, setCopied] = useState(false)
  const [narrow, setNarrow] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 768)
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth <= 768)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return (
    <div style={{ position: 'relative', maxWidth: '100%' }}>
      <pre style={{
        background: colors.bgPage, padding: narrow ? '48px 12px 12px' : '12px', borderRadius: radius.sm,
        border: `1px solid ${colors.border}`, color: colors.textPrimary,
        fontSize: '12px', overflowX: 'auto', whiteSpace: 'pre-wrap',
        wordBreak: 'break-all', margin: '8px 0 0', maxWidth: '100%'
      }}>{code}</pre>
      <button onClick={() => { navigator.clipboard.writeText(code); setCopied(true); setTimeout(() => setCopied(false), 1500) }} style={{
        ...ui.btnSm,
        position: 'absolute', top: narrow ? '12px' : '16px', right: '10px', fontSize: '11px'
      }}>{copied ? 'Kopyalandı ✓' : 'Kopyala'}</button>
    </div>
  )
}

function moduleInstall(key, T) {
  switch (key) {
    case 'smart-search':
      return { steps: [{ desc: 'İzleme Kodları → </body> öncesine ekleyin:', code: `<script src="${SRV}/widget/smart-search.js?token=${T}" defer></script>` }] }
    case 'smart-target':
      return { steps: [{ desc: 'İzleme Kodları → </body> öncesine ekleyin. (Smart View aktifse ayrı script gerekmez, bu kod onu da yükler.)', code: `<script src="${SRV}/widget/smart-target.js?token=${T}" defer></script>` }] }
    case 'smart-view':
      return { shared: true, steps: [{ desc: 'Ayrı script GEREKMEZ — Smart Target veya Recommendation (widget.js) scripti varsa Smart View onunla otomatik yüklenir. İkisi de yoksa ekleyin:', code: `<script src="${SRV}/widget/smart-view.js?token=${T}" defer></script>` }] }
    case 'smart-review':
      return { shared: true, steps: [
        { desc: 'Ayrı script GEREKMEZ — Smart Target veya Recommendation (widget.js) scripti varsa Smart Review onunla otomatik yüklenir. İkisi de yoksa ekleyin:', code: `<script src="${SRV}/widget/smart-review.js?token=${T}" defer></script>` },
        { desc: 'Modül ayarlarında "Yerleşim seçicisi" alanına, ürün detay sayfasında yorum bloğunun ekleneceği elemanın CSS seçicisini yazın.', code: null }
      ] }
    case 'smart-event':
      return { steps: [{ desc: 'İzleme Kodları → </body> öncesine ekleyin:', code: `<script src="${SRV}/widget/smart-event.js?token=${T}" defer></script>` }] }
    case 'smartbot':
      return { steps: [{ desc: 'İzleme Kodları → </body> öncesine ekleyin:', code: `<script src="${SRV}/widget/smartbot.js?token=${T}" defer></script>` }] }
    case 'smart-cart':
      return { steps: [
        { desc: 'Sepet sayfasının TPL dosyasına ekleyin:', code: `<script src="${SRV}/widget/smart-cart.js?token=${T}" defer></script>` },
        { desc: 'Boş sepet önerisi için sepet sayfasının boş-durum alanında şu blok bulunmalı:', code: `<div id="seux-empty-cart"></div>` }
      ] }
    case 'smart-blog':
      return { steps: [{ desc: 'Blog detay sayfasının TPL dosyasına ekleyin:', code: `<script src="${SRV}/widget/smart-blog.js?token=${T}" defer></script>` }] }
    case 'smart-library':
      return { steps: [
        { desc: '1) Favorilerim / Kütüphanem sayfasının içine HTML blok ekleyin:', code: `<div id="seux-library" class="w-full mb-4 lg:mb-6"></div>` },
        { desc: '2) İzleme Kodları\'na inline loader ekleyin (CSP nedeniyle src yerine):', code: `<script>(function(){fetch('${SRV}/widget/smart-library.js?token=${T}').then(function(r){return r.text();}).then(function(c){(0,eval)(c);}).catch(function(){});})();</script>` }
      ] }
    case 'quiz':
      return { steps: [
        { desc: 'İzleme Kodları → </body> öncesine ekleyin:', code: `<script src="${SRV}/widget/quiz.js?token=${T}" defer></script>` },
        { desc: 'Quiz\'in görünmesini istediğiniz sayfaya blok ekleyip quiz bloğunu yerleştirin.', code: null }
      ] }
    case 'smart-video':
      return { noScript: true, steps: [{ desc: 'Ayrı izleme scripti veya element seçimi GEREKMEZ. Modülden aldığınız self-contained Twig bloğunu anasayfada istediğiniz yere blok olarak ekleyin.', code: null }] }
    default:
      return null
  }
}

function Setup() {
  const { selectedBrand, setSelectedBrand } = useBrand()
  const [form, setForm] = useState(null)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [testing, setTesting] = useState(false)
  const [testResult, setTestResult] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (!selectedBrand) return
    const token = localStorage.getItem('adminToken')
    axios.get(`${API}/admin/brands/${selectedBrand.id}`, {
      headers: { Authorization: token }
    }).then(res => setForm(res.data))
  }, [selectedBrand])

  async function handleSave(e) {
    e.preventDefault()
    setSaving(true)
    const token = localStorage.getItem('adminToken')
    await axios.put(`${API}/admin/brands/${selectedBrand.id}`, form, {
      headers: { Authorization: token }
    })
    setSelectedBrand({ ...selectedBrand, ...form })
    setSaved(true)
    setSaving(false)
    setTimeout(() => setSaved(false), 3000)
  }

  async function handleTest() {
    setTesting(true)
    setTestResult(null)
    try {
      const res = await axios.get(
        `${API}/widget/recommend?token=${selectedBrand.widget_token}&productId=test`,
        { timeout: 5000 }
      )
      if (res.data.success !== undefined) {
        setTestResult({ ok: true, message: 'API bağlantısı başarılı, widget çalışıyor.' })
      } else {
        setTestResult({ ok: false, message: 'API yanıt verdi fakat beklenmedik format.' })
      }
    } catch (err) {
      setTestResult({ ok: false, message: 'Bağlantı hatası: ' + err.message })
    }
    setTesting(false)
  }

  if (!selectedBrand) return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <p style={{ ...ui.notice, marginBottom: '16px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={s.btnPrimary}>Markalara Git</button>
    </div>
  )

  if (!form) return <p style={ui.emptyText}>Yükleniyor...</p>

  const T = selectedBrand.widget_token
  const scriptUrl = `${SRV}/widget/download/${T}`

  const ef = form.enabled_features
  const activeKeys = Array.isArray(ef) ? ef : GATEABLE_FEATURES.map(f => f.key)
  const labelOf = k => (GATEABLE_FEATURES.find(f => f.key === k) || {}).label || k

  const installCards = activeKeys
    .map(k => ({ key: k, label: labelOf(k), install: moduleInstall(k, T) }))
    .filter(m => m.install)
  const noInstall = activeKeys
    .filter(k => !moduleInstall(k, T))
    .map(labelOf)

  const recSteps = [
    { title: '1. Global script\'i ekle', desc: 'T-Soft panelinde İzleme Kodları → </head> öncesine ekleyin. Bu tek script window.SeuxSmart\'ı sağlar (Smart View aktifse onu da otomatik yükler). Dosya indirme / FTP gerekmez — script canlı sunucudan çalışır.', code: `<script src="${scriptUrl}" defer></script>` },
    { title: '2. Ürün detay sayfasına blok ekle', desc: 'Yeni blok ekle ve carousel\'in görünmesini istediğin yere konumlandır.', code: null },
    { title: '3. Blok içine recommendation bloğunu ekle', desc: 'Blok editöründe, markaya özel teslim edilen recommendation bloğunu ekle (window.SeuxSmart.fetch ile veri çeker).', code: null }
  ]

  return (
    <div style={{ maxWidth: '820px', width: '100%' }}>
      <h2 style={{ ...s.pageTitle, marginBottom: '24px' }} className="sx-break">Kurulum — {selectedBrand.name}</h2>

      <div style={{ ...s.card, padding: '24px', marginBottom: '24px' }}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>Marka Ayarları</h3>
        <form onSubmit={handleSave}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={s.labelNormal}>Marka Adı</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                style={s.input} />
            </div>
            <div>
              <label style={s.labelNormal}>Site URL</label>
              <input value={form.site_url} onChange={e => setForm({ ...form, site_url: e.target.value })}
                style={s.input} />
            </div>
            <div>
              <label style={s.labelNormal}>Web Servis Kullanıcı Adı</label>
              <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })}
                style={s.input} />
            </div>
            <div>
              <label style={s.labelNormal}>Web Servis Şifresi</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                style={s.input} />
            </div>
            <div>
              <label style={s.labelNormal}>T-Soft Versiyon</label>
              <select value={form.tsoft_version} onChange={e => setForm({ ...form, tsoft_version: e.target.value })}
                style={s.select}>
                <option value="os2">T-Soft OS2 (Yeni)</option>
                <option value="v5">T-Soft V5 (Eski)</option>
              </select>
            </div>
          </div>
          <button type="submit" disabled={saving} style={{
            ...s.btnPrimary,
            opacity: saving ? 0.6 : 1, cursor: saving ? 'not-allowed' : 'pointer'
          }}>
            {saved ? 'Kaydedildi ✓' : saving ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </form>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 4px' }}>Aktif Modül Kurulumları</h3>
        <p style={{ ...s.sectionSubtitle, marginBottom: '16px' }}>Bu markada aktif olan modüllere göre gösteriliyor. Kod kutularındaki token bu markaya özeldir.</p>

        {installCards.length === 0 && (
          <div style={ui.notice}>Site içi kurulum gerektiren aktif modül yok.</div>
        )}

        {installCards.map(m => (
          <div key={m.key} style={{ ...s.cardSm, padding: '20px', marginBottom: '12px' }}>
            <p style={{ fontSize: '14px', fontWeight: 600, color: colors.textPrimary, margin: '0 0 8px' }}>
              {m.label}
              {m.install.shared && <span style={{ ...ui.chip, marginLeft: '10px', fontSize: '11px' }}>ortak script</span>}
              {m.install.noScript && <span style={{ ...ui.chip, marginLeft: '10px', fontSize: '11px' }}>izleme kodu gerekmez</span>}
            </p>
            {m.install.steps.map((step, i) => (
              <div key={i} style={{ marginBottom: i < m.install.steps.length - 1 ? '12px' : 0 }}>
                <p style={{ fontSize: '13px', color: colors.textSecondary }}>{step.desc}</p>
                {step.code && <CodeBox code={step.code} />}
              </div>
            ))}
          </div>
        ))}

        {noInstall.length > 0 && (
          <div style={ui.notice} className="sx-break">
            Site içi kurulum gerektirmeyen aktif modüller (config / sunucu tarafı): {noInstall.join(', ')}
          </div>
        )}
      </div>

      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>Genel Script ve Ürün Öneri Carousel</h3>
        {recSteps.map((step, i) => (
          <div key={i} style={{ ...s.cardSm, padding: '20px', marginBottom: '12px' }}>
            <p style={{ fontSize: '14px', fontWeight: 600, color: colors.textPrimary, margin: '0 0 8px' }}>{step.title}</p>
            <p style={{ fontSize: '13px', color: colors.textSecondary, marginBottom: step.code ? '4px' : 0 }}>{step.desc}</p>
            {step.code && <CodeBox code={step.code} />}
          </div>
        ))}
      </div>

      <div style={{ ...s.card, padding: '24px', marginBottom: 0 }}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 4px' }}>Bağlantı Testi</h3>
        <p style={{ ...s.sectionSubtitle, marginBottom: '16px' }}>Widget API bağlantısını test et.</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }} className="sx-wrap">
          <button onClick={handleTest} disabled={testing} style={{
            ...s.btnSecondary,
            opacity: testing ? 0.6 : 1, cursor: testing ? 'not-allowed' : 'pointer'
          }}>{testing ? 'Test ediliyor...' : 'Bağlantıyı Test Et'}</button>
          {testResult && (
            <span className="sx-break" style={{
              ...(testResult.ok ? s.alertSuccess : s.alertDanger),
              padding: '8px 14px', maxWidth: '100%'
            }}>{testResult.ok ? '✓ ' : '✗ '}{testResult.message}</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default Setup
